// extracted by mini-css-extract-plugin
export default {"custom-options-dropdown":"custom-options-dropdown__kIm5b"};